import { Txt } from "../common/text";
import { Google } from "./google-maps";
import * as $ from "jquery";

export class GoogleMapsModal
{
    private modal: HTMLDivElement;
    private readonly startPlace: any;
    private readonly startRadius?: number;

    constructor(modal: HTMLDivElement, startPlace: any, startRadius?: number)
    {
        this.modal = modal;
        this.startPlace = startPlace;
        this.startRadius = startRadius;
    }

    public showModal(
        onSave: (result: any | { place: any | null; radius: number } | null) => void,
        onClear: () => void,
    )
    {
        this.modal.innerHTML = "";

        const modalDialog = document.createElement("div");
        modalDialog.className = "modal-dialog modal-lg";

        const modalContent = document.createElement("div");
        modalContent.className = "modal-content";

        const modalHeader = document.createElement("div");
        modalHeader.className = "modal-header";
        const title = document.createElement("h4");
        title.className = "modal-title";
        title.innerText = Txt.selectLocation;
        modalHeader.appendChild(title);

        const modalBody = document.createElement("div");
        modalBody.className = "modal-body";
        modalBody.style.cssText = "height:520px;position:relative;display:flex;flex-direction:column;gap:8px";

        const autocompleteElement = document.createElement("gmp-place-autocomplete") as any;
        autocompleteElement.id = "autocomplete";
        autocompleteElement.style.borderRadius = "4px";

        const autocompleteContainer = document.createElement("div");
        autocompleteContainer.appendChild(autocompleteElement);
        modalBody.appendChild(autocompleteContainer);

        const mapContainer = document.createElement("div");
        mapContainer.style.cssText = "flex:1;border:1px solid #ccc";
        modalBody.appendChild(mapContainer);

        let radiusInput: HTMLInputElement | null = null;

        if (this.startRadius != null)
        {
            const radiusContainer = document.createElement("div");
            radiusContainer.style.cssText =
                "display:flex;gap:8px;align-items:center;margin-top:4px";

            const radiusLabel = document.createElement("label");
            radiusLabel.innerText = Txt.radius;
            radiusLabel.style.fontWeight = "600";

            radiusInput = document.createElement("input");
            radiusInput.type = "number";
            radiusInput.className = "form-control";
            radiusInput.style.width = "120px";
            radiusInput.min = "100";
            radiusInput.max = "10000";
            radiusInput.step = "100";
            radiusInput.value = String(this.startRadius);

            radiusContainer.append(radiusLabel, radiusInput);
            modalBody.appendChild(radiusContainer);
        }

        const modalFooter = document.createElement("div");
        modalFooter.className = "modal-footer";

        const saveBtn = document.createElement("button");
        saveBtn.className = "btn btn-primary";
        saveBtn.textContent = Txt.save;

        const clearBtn = document.createElement("button");
        clearBtn.className = "btn btn-secondary";
        clearBtn.textContent = Txt.clear;

        const closeBtn = document.createElement("button");
        closeBtn.className = "btn btn-default";
        closeBtn.textContent = Txt.close;

        modalFooter.append(saveBtn, clearBtn, closeBtn);

        modalContent.append(modalHeader, modalBody, modalFooter);
        modalDialog.appendChild(modalContent);
        this.modal.appendChild(modalDialog);

        const start = this.startPlace ?? { lat: 58.686057, lng: 25.842476 };
        const map = new Google.maps.Map(mapContainer, { zoom: 7, center: start });
        const marker = new Google.maps.Marker({ position: start, map, draggable: true });

        if (radiusInput != null)
        {
            const circle = new Google.maps.Circle({
                map,
                radius: parseInt(radiusInput.value, 10),
                fillColor: "rgba(128, 0, 128, 0.3)",
                strokeColor: "purple",
                strokeOpacity: 0.7
            });
            circle.bindTo("center", marker, "position");

            radiusInput.addEventListener("change", () =>
            {
                let val = parseInt(radiusInput.value, 10) || 500;
                val = Math.max(100, Math.min(10000, val));
                radiusInput.value = val.toString();
                circle.setRadius(val);
            });
        }

        let tempPlace = this.startPlace ? { ...this.startPlace } : null;

        autocompleteElement.addEventListener("gmp-select", async (event: any) =>
        {
            const prediction = event.placePrediction;
            const place = prediction.toPlace();
            await place.fetchFields({ fields: ["formattedAddress", "location"] });

            const loc = place.location;

            tempPlace = {
                placeId: place.id ?? "",
                formattedAddress: place.formattedAddress ?? "",
                lat: loc.lat(),
                lng: loc.lng()
            };

            marker.setPosition(loc);
            map.setCenter(loc);
            map.setZoom(14);
        });

        map.addListener("click", e =>
        {
            const lat = e.latLng.lat();
            const lng = e.latLng.lng();

            marker.setPosition(e.latLng);

            tempPlace = {
                lat,
                lng,
                formattedAddress: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
                placeId: ""
            };
        });

        saveBtn.onclick = () =>
        {
            if (radiusInput)
            {
                const radius = Math.max(
                    100,
                    Math.min(
                        10000,
                        parseInt(radiusInput.value, 10) || this.startRadius
                    )
                );

                onSave({
                    place: tempPlace ? { ...tempPlace } : null,
                    radius
                });
            }
            else
            {
                onSave(tempPlace ? { ...tempPlace } : null);
            }

            $(this.modal).modal("hide");
        };

        clearBtn.onclick = () =>
        {
            tempPlace = null;
            onClear();
            $(this.modal).modal("hide");
        };

        closeBtn.onclick = () =>
        {
            tempPlace = null;
            $(this.modal).modal("hide");
        };

        $(this.modal).modal({ backdrop: "static", keyboard: true, show: true });
    }
}
